var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"layout_simple",scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('div',{staticClass:"section section_flex-center"},[_c('Loader')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }